import { CompassCardUI } from '@scale/compass-ui/types';
import {
  type CreateProjectInviteSchemaType,
  type CreateProjectInviteContext,
  CreateProjectInviteCardShared,
  CREATE_PROJECT_INVITE,
} from '@scale/genai-compass-shared/cards/create_project_invite';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons';
import CreateProjectInviteCardComponent from './CreateProjectInviteCardComponent';
import { VALID_DURATION_DAYS } from 'react-scale/corp/views/CorpProjectGroupManager/views/ThroughputTabs/ForecastComponents/OnboardingComponents/shared/projectInviteConstants';

/**
 * Calculates a default expiresAt date (1 day from now)
 */
function getDefaultExpiresAt(): string {
  const expiresAt = new Date();
  expiresAt.setDate(expiresAt.getDate() + VALID_DURATION_DAYS[0]);
  return expiresAt.toISOString();
}

const defaultContext: CreateProjectInviteContext = {
  cardType: CREATE_PROJECT_INVITE,
  projectId: '',
  expiresAt: getDefaultExpiresAt(),
  batchName: undefined,
  insertOrder: undefined,
  columnIdWithWorkerIds: '',
};

export const CreateProjectInviteCardInfo: CompassCardUI<
  CreateProjectInviteSchemaType,
  CreateProjectInviteContext
> = {
  ...CreateProjectInviteCardShared,
  title: 'Create Project Invites',
  icon: 'envelope',
  toolTip: 'Send early access invitations to contributors for a project',
  defaultContext,
  showOutput: true,
  button: {
    icon: faPaperPlane,
  },
  legacyComponent: CreateProjectInviteCardComponent,
};
